import { Fragment } from 'react';
import { Box, Grid, Typography, useTheme } from '@mui/material';

import MuiTable from 'components/MuiTable';
import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';
import useTableForm from '../../Survey/hooks/useTableForm';

interface Props extends IFormValues, IFormWatch {}

const BedScoreContents = (props: Props) => {
  const { palette } = useTheme();
  const { radioGroup, sumValues } = useTableForm(props);

  const columns = [
    { fieldId: 'title', label: '평가항목' },
    { fieldId: '0', label: '1점' },
    { fieldId: '1', label: '2점' },
    { fieldId: '2', label: '3점' },
    { fieldId: '3', label: '4점' },
  ];

  const rows = [
    {
      id: 'body',
      title: '신체 상태',
      ...radioGroup({
        key: 'contents.body',
        options: [1, 2, 3, 4],
        i18nKey: 'BED.SCORETHREE.BODY',
      }),
      sx: {
        paddingLeft: '50px',
      },
    },
    {
      id: 'mental',
      title: '정신 상태',
      ...radioGroup({
        key: 'contents.mental',
        options: [1, 2, 3, 4],
        i18nKey: 'BED.SCORETHREE.MENTAL',
      }),
      sx: {
        paddingLeft: '50px',
      },
    },
    {
      id: 'activity',
      title: '활동',
      ...radioGroup({
        key: 'contents.activity',
        options: [1, 2, 3, 4],
        i18nKey: 'BED.SCORETHREE.ACTIVITY',
      }),
      sx: {
        paddingLeft: '50px',
      },
    },
    {
      id: 'mobility',
      title: '이동성',
      ...radioGroup({
        key: 'contents.mobility',
        options: [1, 2, 3, 4],
        i18nKey: 'BED.SCORETHREE.MOBILLITY',
      }),
      sx: {
        paddingLeft: '50px',
      },
    },
    {
      id: 'urinary',
      title: '실금',
      ...radioGroup({
        key: 'contents.urinary',
        options: [1, 2, 3, 4],
        i18nKey: 'BED.SCORETHREE.URINARY',
      }),
      sx: {
        paddingLeft: '50px',
      },
    },
  ];

  const watchSumValues = () => {
    const values = rows.map(({ id }) => Number(props.watch(`contents.${id}`)));
    return sumValues(values);
  };

  return (
    <Fragment>
      <SectionTitle title="Norton Sclae" />
      <Grid item xs={12}>
        <MuiTable columns={columns} rows={rows} />
      </Grid>
      <Grid item xs={12}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            variant="subtitle1"
          >
            합계 : {watchSumValues()}점
          </Typography>
          <Typography
            minWidth={115}
            variant="caption"
            sx={{ color: `${palette.primary.main}` }}
          >
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                48% 위험도 :
              </Box>
              0-12점
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                32% 위험도 :
              </Box>
              12-14점
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                21% 위험도 :
              </Box>
              15-17점
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                5% 위험도 :
              </Box>
              18-20점
            </Typography>
          </Typography>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default BedScoreContents;
